export const GET_MESSAGES = 'notification.GET_MESSAGES'
export const SEND_NOTIFICATION = 'notification.SEND_NOTIFICATION'
export const LIST_MESSAGES = 'notification.LIST_MESSAGES'
export const SET_MESSAGES = 'notification.SET_MESSAGES'
export const SET_MESSAGE = 'notification.SET_MESSAGE'
export const GET_MESSAGE = 'notification.GET_MESSAGE'
export const ADD_MESSAGE = 'notification.ADD_MESSAGE'

export const getMessages = (callback) => ({
  type: GET_MESSAGES,
  callback,
})

export const sendNotification = (data, callback) => ({
  type: SEND_NOTIFICATION,
  data,
  callback,
})

export const listMessages = (params, callback) => ({
  type: LIST_MESSAGES,
  params,
  callback,
})

export const setMessages = (data) => ({
  type: SET_MESSAGES,
  data,
})

export const setMessage = (data) => ({
  type: SET_MESSAGE,
  data,
})

export const getMessage = (messageId, callback) => ({
  type: GET_MESSAGE,
  messageId,
  callback,
})

export const addMessage = (data) => ({
  type: ADD_MESSAGE,
  data,
})
